import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const bankColors: Record<string, string> = {
  pending: 'bg-muted text-muted-foreground',
  in_progress: 'bg-warning/10 text-warning',
  opened: 'bg-success/10 text-success',
  failed: 'bg-destructive/10 text-destructive',
};

/**
 * T235: the bank's registration of a signed contract (Loan Manager). `labels` is the locale group of the side it is
 * shown on — `mur_detail.bank_status` (merchant) or `adm_contracts.bank_st` (admin).
 */
export function BankContractBadge({ status, labels }: { status?: string | null; labels: string }) {
  const { t } = useTranslation();
  if (!status) return null;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap', bankColors[status] ?? 'bg-muted text-muted-foreground')}>
      {t(`${labels}.${status}`, { defaultValue: status })}
    </span>
  );
}
